import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  findAllPriceRange,
  findAllActivePriceRange,
  insertPriceRange,
  updatePriceRange,
  deletePriceRange,
  findByIDPriceRange,
  activeInactivePriceRange,
} from "./priceRange.service";
import { IPriceRange, IPriceRangeState } from "./priceRangeModel";

const initialState: IPriceRangeState = {
  loading: false,
  formLoading: false,
  error: "",
  PriceRangeList: [],
  ActivePriceRangeList: [],
  PriceRangeID: null,
  isDrawerOpen: false,
  PriceRangeDetail: {
    ItemQty: null,
    ItemPercentage: null,
    IsActive: true,
  },
  isDeleteModalOpen: false,
  DeletePriceRangeID: null,
};

const priceRangeSlice = createSlice({
  name: "priceRange",
  initialState,
  reducers: {
    setPriceRangeID: (state, action: PayloadAction<number | null>) => {
      state.PriceRangeID = action.payload;
    },
    clearPriceRangeID: (state) => {
      state.PriceRangeID = null;
    },
    clearPriceRangeDetails: (state) => {
      state.PriceRangeDetail = initialState.PriceRangeDetail;
      state.PriceRangeID = null;
    },
    openDrawer: (state) => {
      state.isDrawerOpen = true;
    },
    closeDrawer: (state) => {
      state.isDrawerOpen = false;
      state.PriceRangeID = null;
      state.PriceRangeDetail = initialState.PriceRangeDetail;
    },
    openDeleteModal: (state, action: PayloadAction<number>) => {
      state.DeletePriceRangeID = action.payload;
      state.isDeleteModalOpen = true;
    },
    closeDeleteModal: (state) => {
      state.isDeleteModalOpen = false;
      state.DeletePriceRangeID = null;
    },
  },
  extraReducers: (builder) => {
    // Find All Active
    builder.addCase(findAllActivePriceRange.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      findAllActivePriceRange.fulfilled,
      (state, action: PayloadAction<IPriceRange[]>) => {
        state.loading = false;
        state.ActivePriceRangeList = action.payload || [];
        state.error = "";
      },
    );
    builder.addCase(findAllActivePriceRange.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ActivePriceRangeList = [];
    });

    // Find All
    builder.addCase(findAllPriceRange.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      findAllPriceRange.fulfilled,
      (state, action: PayloadAction<IPriceRange[]>) => {
        state.loading = false;
        state.PriceRangeList = action.payload || [];
        state.error = "";
      },
    );
    builder.addCase(findAllPriceRange.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PriceRangeList = [];
    });

    // Insert
    builder.addCase(insertPriceRange.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(insertPriceRange.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(insertPriceRange.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update
    builder.addCase(updatePriceRange.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updatePriceRange.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updatePriceRange.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Find By ID
    builder.addCase(findByIDPriceRange.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(findByIDPriceRange.fulfilled, (state, action: any) => {
      state.loading = false;
      state.PriceRangeDetail = action.payload;
    });
    builder.addCase(findByIDPriceRange.rejected, (state, action) => {
      state.loading = false;
      state.PriceRangeDetail = initialState.PriceRangeDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete
    builder.addCase(deletePriceRange.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePriceRange.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePriceRange.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Active/Inactive
    builder.addCase(activeInactivePriceRange.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactivePriceRange.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactivePriceRange.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  setPriceRangeID,
  clearPriceRangeID,
  clearPriceRangeDetails,
  openDrawer,
  closeDrawer,
  openDeleteModal,
  closeDeleteModal,
} = priceRangeSlice.actions;

export default priceRangeSlice.reducer;
